import rangeSlider from './RangeSlider';

interface Obj {
  [key: string]: any;
}

class Calculator {
  public calculator: HTMLElement;
  private tab1: HTMLElement;
  private tab2: HTMLElement;
  private resultsNodes: NodeListOf<HTMLElement>;
  private input: HTMLInputElement;
  private valuesTab1: Obj = { '1': 0, '2': 0 };
  private valuesTab2: Obj = { '1': 0, '2': 0 };
  private rangeSliders: Obj[] = [];

  constructor(public selector: string) {
    this.calculator = document.querySelector(selector) as HTMLElement;

    if (this.calculator) {
      this.init();
    }
  }

  private init(): void {
    this.tab1 = this.calculator.querySelector('[data-tab="1"]');
    this.tab2 = this.calculator.querySelector('[data-tab="2"]');
    this.resultsNodes = this.calculator.querySelectorAll(
      '.js-calculator-results'
    );
    this.initTab2Input();
    this.initRangeSliders();
  }

  private initTab2Input(): void {
    this.input = this.calculator.querySelector('#field-staff');

    if (this.input) {
      this.input.value = this.valuesTab1['1'];

      this.input.addEventListener('change', e => {
        this.updateInput(e);
      });

      this.input.addEventListener('keyup', e => {
        this.updateInput(e);
      });
    }
  }

  private updateInput(e: Event): void {
    const val = (e.target as HTMLInputElement).value;
    if (val) {
      this.valuesTab1['1'] = parseFloat(val);
      this.rangeSliders[0].slider.noUiSlider.set(parseFloat(val));
    }
  }

  private initRangeSliders(): void {
    this.tab1
      .querySelectorAll('.js-calculator-range')
      .forEach((range, index): void => {
        const rangeInstance = rangeSlider().init(range);
        this.rangeSliders.push(rangeInstance);
        rangeInstance.onChange((val: string[]) => {
          const [rangeValue] = val;
          this.valuesTab1[`${index + 1}`] = parseFloat(rangeValue);
          this.calculate();
        });
      });

    this.tab2
      .querySelectorAll('.js-calculator-range')
      .forEach((range, index): void => {
        const rangeInstance = rangeSlider().init(range);
        this.rangeSliders.push(rangeInstance);
        rangeInstance.onChange((val: string[]) => {
          const [rangeValue] = val;
          this.valuesTab2[`${index + 1}`] = parseFloat(rangeValue);
          this.calculate();
        });
      });
  }

  private calculate(): void {
    // tab1 calculation
    const { savingConst, workdaysPerMonth } = this.tab1.dataset;

    const resultTab1 =
      parseFloat(savingConst) *
      this.valuesTab1['1'] *
      this.valuesTab1['2'] *
      parseFloat(workdaysPerMonth);

    this.resultsNodes[0].innerHTML = Math.round(resultTab1)
      .toFixed(0)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    this.resultsNodes[1].innerHTML = Math.round(resultTab1 * 12)
      .toFixed(0)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    // tab2 calculation
    const { storageConst } = this.tab2.dataset;
    const resultTab2 =
      this.valuesTab2['1'] * this.valuesTab2['2'] * this.valuesTab1['1'] * 12;
    const storageCosts = resultTab2 * parseFloat(storageConst);
    this.resultsNodes[2].innerHTML = Math.round(resultTab2)
      .toFixed(0)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    this.resultsNodes[3].innerHTML = Math.round(storageCosts)
      .toFixed(0)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    this.resultsNodes[4].innerHTML = Math.round(resultTab2 + storageCosts)
      .toFixed(0)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    // sync input
    this.input.value = this.valuesTab1['1'];
  }
}

export default Calculator;
